module.exports = __webpack_public_path__ + "static/media/icn-ledger.62825e60.svg";